export function useCalendarDate(calendarId: number | null | undefined): Date | null {
  const input = String(calendarId);
  const year = +input.slice(1,5);
  const month = +input.slice(5,7);
  const day = +input.slice(7,9);
  const date = new Date(year, month - 1, day);
  const isValidDate = Boolean(date) && date instanceof Date && !isNaN(+date);
  return isValidDate ? date : null;
}